/**
 * PromptCard — Image to Prompt AI
 *
 * Declares a single web-accessible-resource — `icons/history-icon.png` — matched to
 * every http(s) origin with no `use_dynamic_url`, so it is loadable from any page at a
 * fixed URL. It is the only file the manifest exposes (the other bundled icons are not
 * declared web-accessible).
 *
 * Being an image, it loads through `probeImage` with no CORS grant, so it survives a
 * restrictive page CSP. A successful load is conclusive — served only when installed.
 *
 * Manifest verified against version 1.3.2.
 */

import { probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'pdiegjclbkenbildadfjggoidpkplbmd';

export const promptCard: ExtensionDefinition = {
  id: ID,
  name: 'PromptCard - Image to Prompt AI',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 10_000,
  notes:
    'Single WAR (icons/history-icon.png) exposed to every http(s) origin with no dynamic ' +
    'URL. Loads via <img> without a CORS grant and is conclusive.',
  signals: [
    {
      id: 'war-history-icon',
      kind: 'web-accessible-resource',
      description:
        'Load icons/history-icon.png via <img> — the only web-accessible resource, ' +
        'exposed to every http(s) origin; needs no CORS grant.',
      weight: 1,
      run: () => probeImage(ID, 'icons/history-icon.png'),
    },
  ],
};
